module.exports = __webpack_public_path__ + "img/product_tt.ba32214a.png";